import {
  RelevantLinks,
  AdditionalLinks,
  SocialMediaLinks,
  GamesList,
  games,
  LaunchpadWidget,
} from '@/components/Layouts/Layout'
import { AudioSwitch } from '@/components/atoms/AudioSwitch'
import { Logo } from '@/components/atoms/Logo/Logo'
import { NetworkStatus } from '@/components/atoms/NetworkStatus/NetworkStatus'
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  Flex,
  Center,
  DrawerBody,
  DrawerFooter,
} from '@chakra-ui/react'
import { RiCloseFill } from 'react-icons/ri'

export const MobileMenu = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  return (
    <Drawer isFullHeight={true} isOpen={isOpen} placement="left" size="full" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent bg={'ninja.900'}>
        <DrawerHeader mb={2}>
          <Flex alignItems={'center'} justifyContent={'space-between'}>
            <Logo textStyles={{ fontSize: '22px' }} logoStyles={{ w: 10 }} />
            <Flex gap={2}>
              <AudioSwitch />
              <Center
                marginRight={2}
                color={'ninja.200'}
                onClick={onClose}
                bg={'ninja.600'}
                cursor="pointer"
                h={12}
                w={12}
                transition={'0.1s'}
                _hover={{ bg: 'ninja.500', color: 'ninja.100' }}
                rounded={'2xl'}
              >
                <RiCloseFill size={29} />
              </Center>
            </Flex>
          </Flex>
        </DrawerHeader>
        <DrawerBody>
          <GamesList games={games} />
          {/* <LaunchpadWidget /> */}
          <RelevantLinks onClose={onClose} />
        </DrawerBody>

        <DrawerFooter flexDir={'column'} alignItems={'center'} gap={4}>
          <NetworkStatus />
          <SocialMediaLinks />
          <AdditionalLinks />
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}
